// extracted by mini-css-extract-plugin
export var compact = "PricingFeatureTable-module--compact--2072c";
export var contentTable = "PricingFeatureTable-module--contentTable--e91a9";
export var featured2 = "PricingFeatureTable-module--featured-2--44b8a";
export var featured3 = "PricingFeatureTable-module--featured-3--58f3a";
export var featured4 = "PricingFeatureTable-module--featured-4--413be";
export var featured5 = "PricingFeatureTable-module--featured-5--50871";
export var pricingTable = "PricingFeatureTable-module--pricingTable--b78cd";
export var tableSection = "PricingFeatureTable-module--tableSection--58f09";